'use strict';

$(function() {
  function autoTap() {
    const width = $(document).width()
    if (width > 768) {
      return
    }
    const mobileImageEverybody = $('.visual-event-image-2025');
    const autoChangeInterval = setInterval(() => {
      const visibleImage = $('.main-container:not(.hidden)');
      if (visibleImage.length) {
        const currentIndex = parseInt(visibleImage.attr('id').slice(-1));
        visibleImage.addClass('hidden');
        const nextIndex = (currentIndex + 1) > mobileImageEverybody.length ? 1 : (currentIndex + 1);
        $(`#visual-event-image-2025-${nextIndex}`).removeClass('hidden');
      }
    }, 5000);
    return autoChangeInterval
  }
	function setup() {
        Fancybox.bind("[data-fancybox]", {});

        const swiper = new Swiper('.swiper', {
            autoplay: {
                delay: 2000,
            },

            // Optional parameters
            direction: 'horizontal',
            loop: true,

            autoScrollOffset: 0,
            multipleActiveThumbs: true,
            slideThumbActiveClas: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs',
          
            // If we need pagination
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
          
            // Navigation arrows
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          });

        const container = document.getElementById("myCarousel");
        const options = {
          Autoplay: {
            timeout: 5000,
            showProgressbar: false
          },
          Toolbar: {
            absolute: true,
            enabled: true,
            display: {
              right: ["fullscreen"],
            },
          },
          Lazyload: {
            preload: 4,
          }
        };
        if (container){
          Carousel(container, options, {
            Autoplay,
            Arrows,
            Toolbar,
            Fullscreen,
            Lazyload
          }).init();
        }

        
        const visualEventImage = $('#visual-event-image');
        const headerHeight = $('header').outerHeight();
        const documentHeight = $(window).outerHeight();
        visualEventImage.height(documentHeight - headerHeight - 40);
        
        const visualEventImage_2025 = $('.visual-event-image-2025');
        visualEventImage_2025.height(documentHeight - headerHeight - 200);

        const imageCarrousel = $('.image-carrousel');
        const documentWidth = $(window).outerWidth();
        if (documentWidth < 768){
          imageCarrousel.height(300);
        } else {
          imageCarrousel.height(600);
        }

        // const imageCarrousel = $('.image-carrousel');
        // imageCarrousel.height(documentHeight - headerHeight - 400);

        const hideButton = $('#hide_info_ticketing');
        if (hideButton){
          hideButton.on('click', function() {
            console.log('click');
            $('#info_ticketing').hasClass('hidden') ? hideButton.text('Masquer les informations') : hideButton.text('Afficher les infomations');
            $('#info_ticketing').toggleClass('hidden');
          });
        }


        const mobileImageEverybody = $('.visual-event-image-2025');

        // Auto change image every 5 seconds
        autoTap()
        if (mobileImageEverybody.length) {
          mobileImageEverybody.each(function() {
            const element = $(this);
            element.on('touchstart', function(e) {
              const width = $(document).width()
                if (width > 768) {
                  return
                }
                if (e.target.src.includes('everybody_LP.jpg')){
                  return;
                }
                const pictureElem = e.target.parentElement
                const index = parseInt(e.target.parentElement.id.slice(-1));
                pictureElem.classList.add('hidden');
                const nextIndex = (index + 1) > mobileImageEverybody.length ? 1 : (index + 1);
                const nextPictureElem = $(`#visual-event-image-2025-${nextIndex}`);
                nextPictureElem.removeClass('hidden');
            });
          });
        }

        var instEmailModal = $('[data-remodal-id=emailModal]').remodal();
        var instContactModal = $('[data-remodal-id=contactModal]').remodal();

        const csrfElement = document.getElementsByName("csrfmiddlewaretoken");
        let csrftoken = null;
        if (csrfElement){
          csrftoken = csrfElement[0].value
        }
        const emailInput = document.getElementById("email");
        document.getElementById("sendBtnEmail").addEventListener("click", () => {
          fetch("/register_email/", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "X-CSRFToken": csrftoken
              },
              body: JSON.stringify({
                "email": emailInput.value
              })
          })
          .then(res => {
            if (res.status === 201){
              alert("Merci ! Ton e-mail a été enregistré.");
              instEmailModal.close();
              emailInput.value = "";
              return;
            } else {
              return res.json()
            }
          }).then(data => {
              if (!data){
                return;
              }
              alert(JSON.stringify(data));
              instEmailModal.close();
              emailInput.value = "";
          })
          .catch(err => console.error("Erreur API :", err));
      });

      const messageInput = document.getElementById("message");
      document.getElementById("sendBtnMessage").addEventListener("click", () => {
        fetch("/messages/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
              "message": messageInput.value
            })
        })
        .then(res => {
          if (res.status === 201){
            alert("Merci ! Ton message a été envoyé.");
            instContactModal.close();
            messageInput.value = "";
            return;
          } else {
            return res.json()
          }
        }).then(data => {
            if (!data){
              return;
            }
            alert(JSON.stringify(data));
            instContactModal.close();
            messageInput.value = "";
        })
        .catch(err => console.error("Erreur API :", err));
    });

	}
    setup();
});
